import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActividadEconomicaEntry } from 'src/app/shared/entrys/actividad-economica.entry';

@Component({
  selector: 'app-modal-validar-actividades-economicas',
  templateUrl: './modal-validar-actividades-economicas.component.html',
  styleUrls: ['./modal-validar-actividades-economicas.component.scss']
})
export class ModalValidarActividadesEconomicasComponent implements OnInit {

  @Input()
  mensaje: string;

  @Input()
  descripcionCorrespondenciaSubCategoria: string;

  @Input()
  actividadesEconomicas: ActividadEconomicaEntry[] = [];

  headers = ["Código", "Descripción", "Origen"];

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  confirm(): void {
    if (this.activeModal) {
      this.activeModal.close();
    }
  }

}
